@if (comment) {
    <div (scrollFinished)="isRequiredScrollToComment && startBlinkAnimation()"
         [@doubleBlink]="blinkState"
         [appScrollIntoView]="isRequiredScrollToComment"
         class="flex-row gap-15 p-15 borderTop"
         classTarget="commentTarget">
        @if (!isMobile) {
            @if (comment.author && comment.author?.id > 0) {
                <div>
                    <div [matMenuTriggerFor]="menu" class="moderator clickable"
                         (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false">
                        <app-online-status-badge [isStaff]="comment.author?.is_staff"
                                                 [userId]="comment.author.id"></app-online-status-badge>
                    </div>
                    <div [appUserAvatar]="comment.author" [matMenuTriggerFor]="menu"
                         (menuOpened)="this.userInfoMenuOpen = true" (menuClosed)="this.userInfoMenuOpen = false"
                         class="miniInitial bg-primary mb-0 clickable"
                         [class.onlineIndicatorOffset]="!community?.disable_online_icon_next_to_profile_picture || comment.author?.is_staff"
                         mat-card-avatar>
                    </div>
                    <mat-menu #menu="matMenu" class="userDisplayMenu">
                        @if (userInfoMenuOpen) {
                            <app-user-info [user]="comment.author"></app-user-info>
                        }
                    </mat-menu>
                </div>
            } @else {
                <div class="miniInitial bg-primary mb-0" mat-card-avatar matTooltip="This post was posted anonymously">A
                </div>
            }
        }
        <div class="flex-col w-100 commentTarget">
            <div class="flex-row flex-space-between flex-wrap">
                @if (isMobile) {
                    @if (comment.author && comment.author?.id > 0 && isMobile) {
                        <div>
                            <div [matMenuTriggerFor]="menu" class="moderator clickable"
                                 (menuOpened)="this.userInfoMenuOpen = true"
                                 (menuClosed)="this.userInfoMenuOpen = false">
                                <app-online-status-badge [isStaff]="comment.author?.is_staff"
                                                         [userId]="comment.author.id"></app-online-status-badge>
                            </div>
                            <div [appUserAvatar]="comment.author" [matMenuTriggerFor]="menu"
                                 (menuOpened)="this.userInfoMenuOpen = true"
                                 (menuClosed)="this.userInfoMenuOpen = false"
                                 class="miniInitial bg-primary mb-0 clickable"
                                 mat-card-avatar>
                            </div>
                            <mat-menu #menu="matMenu" class="userDisplayMenu">
                                @if (userInfoMenuOpen) {
                                    <app-user-info [user]="comment.author"></app-user-info>
                                }
                            </mat-menu>
                        </div>
                    } @else {
                        <div class="miniInitial bg-primary mb-0" mat-card-avatar
                             matTooltip="This post was posted anonymously">A
                        </div>
                    }
                }
                <div class="flex-row align-items-center gap-15">
                    @if (child) {
                        <mat-icon class="replyIcon" matTooltip="Comment reply">reply</mat-icon>
                    }
                    <p class="m-0">{{ comment.author?.username || 'Anonymous' }}</p>
                    @if (getAccessDisplay(comment.author.access_level)) {
                        <div [style.background-color]="community?.main_color_hex"
                             [style.color]="themeService.getReadableColor(community?.main_color_hex)"
                             class="flex-row align-items-center justify-content-center gap-5 streakPill flarePill">
                            {{ getAccessDisplay(comment.author.access_level)}}
                        </div>
                    }
                    @if (comment.flare) {
                        <div [style.color]="comment.flare.text_colour_hex"
                             [style.--flare-text-color]="comment.flare.text_colour_hex"
                             [style.background-color]="comment.flare.background_colour_hex"
                             class="flex-row align-items-center justify-content-center gap-5 streakPill flarePill"
                             [innerHTML]="comment.flare.content_rendered|| comment.flare.content || comment.flare.title">
                        </div>
                    }
                    @for (streak of streaks; track streak) {
                        <div class="flex-row bg-primary align-items-center justify-content-center gap-5 streakPill"
                             [matBadge]="streak.current_streak_length"
                             [matBadgeSize]="'small'" [matBadgePosition]="'before'">
                            <img [src]="streak.image" [alt]="streak.name"
                                 class="img clickable" [matTooltip]="streak.description">
                            <p>{{ streak.name }}</p>
                        </div>
                    }
                    <small class="muted">{{ comment.created_at | relativeTime }}</small>
                    @if (comment.is_pinned) {
                        <small class="d-flex align-items-center">
                            <mat-icon class="smallerPinnedIcon" svgIcon="thumbtackIcon"></mat-icon>
                            Pinned</small>
                    }
                </div>
                <div class="flex-row gap-5">
                    @if (comment.is_anonymous && !userIsNotCommentAuthor) {
                        <mat-chip class="noCursorEvents">Posted
                            Anonymously
                        </mat-chip>
                    }
                    @if ((isSuperuser || hasCommunityRole(['full_admin']) && (this.commentFlares && this.commentFlares?.length > 0))) {
                        <button [matMenuTriggerFor]="menu"
                                aria-label="Add Comment Flare"
                                class="delete-icon-button"
                                mat-icon-button matTooltip="Add Comment Flare">
                            <mat-icon>label</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="userDisplayMenu">
                            <div class="flex-col gap-10 p-10 flareSelect">
                                @for (flare of commentFlares; track flare) {
                                    <div [style.color]="flare.text_colour_hex"
                                         [style.--flare-text-color]="flare.text_colour_hex"
                                         [style.background-color]="flare.background_colour_hex"
                                         [class.selected]="comment?.flare?.id == flare.id"
                                         (click)="selectFlare(flare.id)"
                                         [matTooltip]="comment?.flare?.id == flare.id? 'Remove Current Flare': '' "
                                         matTooltipPosition="before"
                                         class="flex-row align-items-center justify-content-center gap-5 streakPill flarePill"
                                         [innerHTML]="flare.content_rendered">
                                    </div>
                                }
                            </div>
                        </mat-menu>
                    }
                    @if ((isSuperuser || hasCommunityRole(['full_admin', 'moderator'])) && !comment.moderated) {
                        <button (click)="moderateComment()"
                                aria-label="Mark as moderated"
                                class="delete-icon-button"
                                mat-icon-button matTooltip="Mark as moderated">
                            <mat-icon>check_circle</mat-icon>
                        </button>
                    }
                    @if ((isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'client'])) && userIsNotCommentAuthor && !comment.is_flagged_for_review) {
                        <button (click)="reportComment()"
                                aria-label="Report comment" class="delete-icon-button"
                                mat-icon-button matTooltip="Flag comment">
                            <mat-icon>report</mat-icon>
                        </button>
                    }
                    @if ((isSuperuser || hasCommunityRole(['full_admin'])) && comment.is_flagged_for_review) {
                        <button (click)="unflagComment()"
                                aria-label="Report comment"
                                class="delete-icon-button"
                                mat-icon-button matTooltip="Un-flag comment">
                            <mat-icon>report_off</mat-icon>
                        </button>
                    }
                    @if ((isSuperuser || hasCommunityRole(['full_admin'])) && comment.hidden) {
                        <button (click)="hideComment()"
                                aria-label="Show comment"
                                class="delete-icon-button"
                                mat-icon-button matTooltip="Show comment">
                            <mat-icon>speaker_notes</mat-icon>
                        </button>
                    }
                    @if ((isSuperuser || hasCommunityRole(['full_admin'])) && !comment.hidden) {
                        <button (click)="hideComment()"
                                aria-label="Hide comment"
                                class="delete-icon-button"
                                mat-icon-button matTooltip="Hide comment">
                            <mat-icon>speaker_notes_off</mat-icon>
                        </button>
                    }
                    @if ((isSuperuser || hasCommunityRole(['full_admin'])) && !comment.is_pinned && comment.moderated && !comment.hidden) {
                        <button (click)="pinComment()"
                                aria-label="Pin comment"
                                class="delete-icon-button"
                                mat-icon-button matTooltip="Pin comment">
                            <mat-icon svgIcon="thumbtackIcon"></mat-icon>
                        </button>
                    }
                    @if ((isSuperuser || hasCommunityRole(['full_admin'])) && comment.is_pinned) {
                        <button (click)="pinComment()"
                                aria-label="Un-pin comment"
                                class="delete-icon-button"
                                mat-icon-button matTooltip="Un-pin comment">
                            <mat-icon svgIcon="unPinIcon"></mat-icon>
                        </button>
                    }
                    @if (userCanDeleteComment || !userIsNotCommentAuthor) {
                        <button (click)="deleteComment()"
                                aria-label="Delete comment"
                                class="delete-icon-button"
                                mat-icon-button matTooltip="Delete comment">
                            <mat-icon>delete</mat-icon>
                        </button>
                    }
                </div>
            </div>
            @if ((isSuperuser || hasCommunityRole(['full_admin']) || hasCommunityRole(['moderator'])) && (comment.hidden || comment.is_flagged_for_review || !comment.moderated)) {
                <div class="flex-row gap-15">
                    @if (comment.hidden) {
                        <div class="commentStatus">Hidden</div>
                    }
                    @if (comment.is_flagged_for_review) {
                        <div class="commentStatus">Flagged for review</div>
                    }
                    @if (!comment.moderated) {
                        <div class="commentStatus">Un-Moderated</div>
                    }
                </div>
            }

            <!--        app-post-content now works for dynamic content of comments also-->
            @if (!editing) {
                <app-post-content [content]="comment" [disableOverlay]="true"
                                  [isCommentStyle]="true"></app-post-content>
            }
            @if (editing) {
                <app-reply-field (action)="updateComment($event)" [initialCommentData]="comment"
                                 [isOpenState]="true" [post]="post"></app-reply-field>
            }
            <!--        <ng-container *ngIf="editing">-->
            <!--            <div class="d-flex flex-row w-100 gap-10 mt-10">-->
            <!--                <div class="flex-auto">-->
            <!--                    <mat-form-field appearance="outline" class="whiteField w-100" color="primary">-->
            <!--                    <textarea matInput maxlength="400" required [formControl]="commentEdit"-->
            <!--                              rows="3"></textarea>-->
            <!--                        <mat-error>-->
            <!--                            This field is required-->
            <!--                        </mat-error>-->
            <!--                    </mat-form-field>-->
            <!--                </div>-->
            <!--                <div class="flex-col flex-space-between"-->
            <!--                     *ngIf=" post.emoji_enabled && this.selectedCommunity?.emoji_enabled">-->
            <!--                    <app-emoji-menu [formControl]="commentEdit" ngDefaultControl matSuffix></app-emoji-menu>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--        </ng-container>-->
            @if (!editing) {
                <div class="flex-row actionsRow flex-wrap">
                    <button (click)="likeComment(comment)" [class.empty-state]="!comment.is_liked"
                            [class.mat-mdc-raised-button]="comment.is_liked ? community?.like_comment_button_bg_color_hex: ''"
                            [disabled]="post.likes_off || !(userIsNotCommentAuthor && (isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'member'])))"
                            [style.background-color]="comment.is_liked ?community?.like_comment_button_bg_color_hex: ''"
                            [style.color]="comment.is_liked ?this.themeService.getReadableColor(community?.like_comment_button_bg_color_hex): ''"
                            class="comment-action-btn"
                            mat-button>
                        <mat-icon [@likeAnimation]="comment.is_liked ? 'active' : 'inactive'">thumb_up</mat-icon>
                        {{ comment.likes_count }}
                    </button>
                    <button (click)="dislikeComment(comment)" [class.empty-state]="!comment.is_disliked"
                            [class.mat-mdc-raised-button]="comment.is_disliked ?community?.dislike_comment_button_bg_color_hex: ''"
                            [disabled]="post.likes_off || !(userIsNotCommentAuthor && (isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'member'])))"
                            [style.background-color]="comment.is_disliked? community?.dislike_comment_button_bg_color_hex: ''"
                            [style.color]="comment.is_disliked? this.themeService.getReadableColor(community?.dislike_comment_button_bg_color_hex): ''"
                            class="comment-action-btn"
                            mat-button>
                        <mat-icon [@likeAnimation]="comment.is_disliked ? 'active' : 'inactive'">thumb_down</mat-icon>
                        {{ comment.dislikes_count }}
                    </button>
                    @if (isSuperuser || !userIsNotCommentAuthor) {
                        <button (click)="editComment()" class="comment-action-btn"
                                mat-button>
                            <mat-icon>edit</mat-icon>
                            Edit Comment
                        </button>
                    }
                    @if (isSuperuser || hasCommunityRole(['full_admin']) || (hasCommunityRole(['client', 'member']))) {
                        <button (click)="!post.comments_off && replyComment(comment)"
                                [disabled]="post.comments_off" class="comment-action-btn"
                                mat-button>
                            <mat-icon>chat_bubble</mat-icon>
                            Reply
                        </button>
                    }
                    @if (comment?.children?.length > 0 && !community?.disable_comment_collapsing) {
                        <button (click)="comment.minimiseReplies = !comment.minimiseReplies"
                                class="comment-action-btn"
                                mat-button>
                            @if (!comment.minimiseReplies) {
                                <mat-icon>expand_less</mat-icon>
                                Hide Replies ({{ comment?.children?.length }})
                            }
                            @if (comment.minimiseReplies) {
                                <mat-icon>expand_more</mat-icon>
                                Show Replies ({{ comment?.children?.length }})
                            }
                        </button>
                    }
                </div>
            }
        </div>
    </div>
}
@if (comment && (replyCommentId | async) === comment.id) {
    <app-reply-field [isOpenState]="true" [isReply]="true"
                     [post]="post" [initialMention]="replyCommentId? comment.author: null"
                     class="d-block ml-20"></app-reply-field>
}


